<template>
	<div id="settings-menu" :class="{ opened: settingsMenuOpened }">
		<ul>
			<li @click="$modal.show('language-settings')">Language</li>
			<li @click="$modal.show('playlists-settings')">{{ $t("menu.playlists") }}</li>
			<li @click="$modal.show('look-settings')">{{ $t("menu.look") }}</li>
			<li @click="$modal.show('control-settings')">{{ $t("menu.control") }}</li>
			<li @click="$modal.show('session-settings')">{{ $t("menu.sessions") }}</li>
			<li @click="$modal.show('membership')">{{ $t("menu.membership") }}</li>
			<li @click="$modal.show('export')">{{ $t("menu.export") }}</li>
			<li @click="$modal.show('user-settings')">{{ $t("menu.user") }}</li>
		</ul>
	</div>
</template>

<script>
	import { mapState } from "vuex";

	export default {
		computed: {
			...mapState([ "settingsMenuOpened" ])
		},
		methods: {
			onClick() {
				setTimeout(() => {
					document.removeEventListener("click", this.onClick);
					document.removeEventListener("touchend", this.onClick);
					this.$store.commit("setSettingsMenuOpened", false);
				}, 200);
			}
		},
		watch: {
			settingsMenuOpened(opened) {
				if (opened) {
					setTimeout(() => {
						document.addEventListener("click", this.onClick);
						document.addEventListener("touchend", this.onClick);
					}, 200);
				}
			}
		},
		destroyed() {
			document.removeEventListener("click", this.onClick);
			document.removeEventListener("touchend", this.onClick);
		}
	}
</script>

<style lang="scss">
	#settings-menu {
		background-color: #323a40;
		position: fixed;
		top: -355px;
		right: 0;
		width: 140px;
		height: auto;
		padding: 0;
		color: rgba(255, 255, 255, 0.8);

		-webkit-transition: top 0.2s;
		-moz-transition: top 0.2s;
		-o-transition: top 0.2s;
		transition: top 0.2s;

		&.opened {
			top: 50px;
			top: calc(constant(safe-area-inset-top) + 50px);
			top: calc(env(safe-area-inset-top) + 50px);
			right: 0;
		}

		ul {
			padding: 0;
			margin: 0;
			list-style: none;

			li {
				width: 120px;
				height: 40px;
				padding: 0 10px;
				line-height: 40px;
				background-color: #356173;
				font-weight: 300;
				color: rgba(255, 255, 255, 0.8);
				border: 0;
				margin: 0 0 5px 0;
				cursor: pointer;
				text-align: center;

				&:hover {
					opacity: 0.9;
				}
			}
		}

	}
</style>
